import Flickity from 'flickity';
import './plugins/gridzy.min.js';
import Marzipano from './plugins/marzipano.js';
import './plugins/jquery-easing.min.js';
import './plugins/easypiechart.min.js';
import ModuloBox from './plugins/modulobox.js';
import 'bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import mixitup from 'mixitup';
import 'flickity-fullscreen';

import './submit-form.js';

AOS.init();

(function($) {
    "use strict"; // Start of use strict

    if(/\?fail|\?success/.test(window.location.href)) {
        $('#reageerDirect').modal();

        window.history.replaceState(null, null, window.location.pathname);
    }

    if($('#pano').length > 0) {
        // Create viewer.
        var viewer = new Marzipano.Viewer(document.getElementById('pano'));

        // Create source.
        var source = Marzipano.ImageUrlSource.fromString(
            $("#pano").attr('data-sphere')
        );

        // Create geometry.
        var geometry = new Marzipano.EquirectGeometry([{width: 6000}]);

        // Create view.
        var limiter = Marzipano.RectilinearView.limit.traditional(1024, 100 * Math.PI / 180);
        var view    = new Marzipano.RectilinearView({yaw: Math.PI}, limiter);

        // Create scenemaz
        var scene = viewer.createScene({
            source:        source,
            geometry:      geometry,
            view:          view,
            pinFirstLevel: true
        });

        // Display scene.
        scene.switchTo();

        if($('.change-pano').length > 0) {
            $('.change-pano > li').click(function() {
                // Create source.
                var source = Marzipano.ImageUrlSource.fromString($(this).attr('data-sphere-photo'));

                // Create scenemaz
                var scene = viewer.createScene({
                    source:        source,
                    geometry:      geometry,
                    view:          view,
                    pinFirstLevel: true
                });

                // Display scene.
                scene.switchTo();
            });
        }
    }

    if($('.sortable-container').length > 0) {
        var mixer = mixitup($('.sortable-container'), {
            animation: {
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
            }
        });

        $('[data-filtertype]').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');

                if($('[data-type].active').length > 0) {
                    mixer.filter($('[data-type].active').data('type'));
                } else {
                    mixer.filter('all');
                }
            } else {
                $('[data-filtertype]').removeClass('active');
                $(this).addClass('active');

                if($('[data-type].active').length > 0) {
                    mixer.filter($(this).data('filtertype') + $('[data-type].active').data('type'));
                } else {
                    mixer.filter($(this).data('filtertype'));
                }
            }
        });

        $('[data-type]').click(function() {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');

                if($('[data-filtertype].active').length > 0) {
                    mixer.filter($('[data-filtertype].active').data('filtertype'));
                } else {
                    mixer.filter('all');
                }
            } else {
                $('[data-type]').removeClass('active');
                $(this).addClass('active');

                if($('[data-filtertype].active').length > 0) {
                    mixer.filter($('[data-filtertype].active').data('filtertype') + $(this).data('type'));
                } else {
                    mixer.filter($(this).data('type'));
                }
            }
        });

        if(/\?cat=/.test(window.location.href)) {
            var category = window.location.href.replace(/.*\?cat=(.*)/, "$1");
            if(category !== '' && $('[data-filtertype=".filter-' + category + '"]').length === 1) {
                $('[data-filtertype=".filter-' + category + '"]').click();

                window.history.replaceState(null, null, window.location.pathname);
            }
        }

        if(/\?type=/.test(window.location.href)) {
            var type = window.location.href.replace(/.*\?type=(.*)/, "$1");
            if(type !== '' && $('[data-type=".filter-' + type + '"]').length === 1) {
                $('[data-type=".filter-' + type + '"]').click();

                window.history.replaceState(null, null, window.location.pathname);
            }
        }
    }

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: (target.offset().top - 100)
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    if(document.querySelector('.property-maps')) {
        const mapFlickity = new Flickity('.property-maps', {
            fullscreen: true,
            draggable:  true,
            lazyLoad:   2
        });
    }

    // FLICKITY
    var elem = document.querySelector('.property-carousel-1');
    if(elem !== null) {
        const options = {
            cellAlign:  'left',
            freeScroll: true,
            //wrapAround:      true,
            groupCells:      true,
            draggable:       true,
            prevNextButtons: true,
            pageDots:        false,
        }

        new Flickity(elem, options);
    }

    var elem = document.querySelector('.property-carousel-2');
    if(elem !== null) {
        var flkty = new Flickity(elem, {
            cellAlign:       'left',
            freeScroll:      true,
            wrapAround:      true,
            groupCells:      false,
            draggable:       true,
            prevNextButtons: true,
            pageDots:        false,
        });
    }

    // Piecharts
    $('.piechart').each(function() {
        var chart = $(this),
            value = chart.attr('data-value') * 1;
        chart.easyPieChart({
            animate:    2000,
            barColor:   '#FFA800',
            scaleColor: '#1C2F58',
            lineWidth:  10
        });
        chart.data('easyPieChart').update(value);
    });


    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Accordions
    $('.usp li').click(function() {
        if($(this).closest('.usp').hasClass('one-open')) {
            $(this).closest('.usp').find('li').removeClass('active');
            $(this).addClass('active');
        } else {
            $(this).toggleClass('active');
        }
        if(typeof window.mr_parallax !== "undefined") {
            setTimeout(mr_parallax.windowLoad, 500);
        }
    });

    // Tabbed Content

    $('.tabbed-content').each(function() {
        $(this).append('<ul class="content"></ul>');
    });

    $('.tabs li').each(function() {
        var originalTab = $(this),
            activeClass = "";
        if(originalTab.is('.tabs>li:first-child')) {
            activeClass = ' class="active"';
        }
        var tabContent = originalTab.find('.tab-content').detach().wrap('<li' + activeClass + '></li>').parent();
        originalTab.closest('.tabbed-content').find('.content').append(tabContent);
    });

    $('.tabs li').click(function() {
        $(this).closest('.tabs').find('li').removeClass('active');
        $(this).addClass('active');
        var liIndex = $(this).index() + 1;
        $(this).closest('.tabbed-content').find('.content>li').removeClass('active');
        $(this).closest('.tabbed-content').find('.content>li:nth-of-type(' + liIndex + ')').addClass('active');
    });

    // Icon bulleted lists
    $('ul[data-bullet]').each(function() {
        var bullet = $(this).attr('data-bullet');
        $(this).find('li').prepend('<i class="' + bullet + '"></i>');
    });

    // Append .background-image-holder <img>'s as CSS backgrounds

    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // Fade in background images

    setTimeout(function() {
        $('.background-image-holder').each(function() {
            $(this).addClass('fadeIn');
        });
    }, 0);

    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').click(function() {
        $('.navbar-collapse').collapse('hide');
    });

    // Activate scrollspy to add active class to navbar items on scroll
    $('body').scrollspy({
        target: '#mainNav',
        offset: 80
    });


    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {

        if(window.cubeRAF) {

            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;

        }

    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {

        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }

    });

    modulobox.init();

    // Collapse Navbar
    var navbarCollapse = function() {
        if($("#mainNav").offset().top > 100) {
            $("#mainNav").addClass("navbar-shrink");
        } else {
            $("#mainNav").removeClass("navbar-shrink");
        }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

})(jQuery); // End of use strict

$(window).on('load', function() {

    /**
     * Resize tailor-made-item to make them have the same height.
     */
    if($('.tailor-made-item').length > 0) {
        var height = 0;
        $('.tailor-made-item > div').each(function() {
            if($(this).height() > height) {
                height = $(this).height();
            }
        });

        $('.tailor-made-item > div').height(height);
    }

    /**
     * Google maps initialisation.
     */
    if($('#google-map').length > 0) {
        var pointsOfInterest      = [];
        var timeout               = false;
        var infowindow            = new google.maps.InfoWindow();
        var streetViewService     = new google.maps.StreetViewService();
        var streetViewMaxDistance = 100;
        var map                   = new google.maps.Map(document.getElementById('google-map'), {
            zoom:              16,
            center:            {
                lat: $('#google-map').data('lat'),
                lng: $('#google-map').data('lng')
            },
            mapTypeControl:    false,
            scaleControl:      false,
            streetViewControl: false,
            rotateControl:     false,
            fullscreenControl: false,
        });

        var panorama = map.getStreetView();
        var point    = new google.maps.LatLng($('#google-map').data('lat'), $('#google-map').data('lng'));

        streetViewService.getPanoramaByLocation(point, streetViewMaxDistance, function(streetViewPanoramaData, status) {
            if(status === google.maps.StreetViewStatus.OK && /Google/.test(streetViewPanoramaData.copyright)) {
                var oldPoint = point;
                point        = streetViewPanoramaData.location.latLng;

                var heading = google.maps.geometry.spherical.computeHeading(point, oldPoint);

                panorama.setPosition(point);
                panorama.setPov({
                    heading: heading,
                    zoom:    1,
                    pitch:   0
                });
            } else {
                // No streetview is found. Also no streetview by Google could be
                // found. If it isn't by Google we can safely assume it is the
                // inside of another store/house etc. And choose not to show it.
                $('[data-selectmap="streetview"]').remove();
            }
        });

        var marker = new google.maps.Marker({
            icon:     '/img/map-markers/home.png',
            map:      map,
            position: {
                lat: $('#google-map').data('lat'),
                lng: $('#google-map').data('lng')
            }
        });

        if($('[data-category]').length > 0) {
            $('[data-category]').data('shown', false);
            $('[data-category]').click(function(e) {
                e.preventDefault();

                if(timeout === false) {
                    timeout = true;

                    if($(this).data('shown') === true) {
                        $(this).data('shown', false);
                    } else {
                        $(this).data('shown', true);
                    }

                    setPointsOfInterest();
                }
            });
        }

        if($('[data-selectmap]').length > 0) {
            $('[data-selectmap]').click(function(e) {
                e.preventDefault();
                if(!$(this).hasClass('active-for-real')) {
                    $('[data-selectmap]').removeClass('active-for-real');
                    $(this).addClass('active-for-real');
                    switch($(this).data('selectmap')) {
                        case 'map':
                            $('.map-categories').fadeIn();
                            map.setMapTypeId('roadmap');
                            panorama.setVisible(false);
                            break;

                        case 'satellite':
                            $('.map-categories').fadeIn();
                            map.setMapTypeId('hybrid');
                            panorama.setVisible(false);
                            break;

                        case 'streetview':
                            $('.map-categories').fadeOut();
                            panorama.setVisible(true);
                            break;
                    }
                }
            });
        }
    }

    function createMarker(place, icon) {
        var placeLocation = place.geometry.location;
        var marker        = new google.maps.Marker({
            map:      map,
            icon:     '/img/map-markers/' + icon + '.png',
            position: placeLocation
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.setContent(place.name);
            infowindow.open(map, this);
        });

        pointsOfInterest.push(marker);
    }

    function setPointsOfInterest() {
        clearPointsOfInterestMarkers();
        $('[data-category]').each(function() {
            if($(this).data('shown') === true) {
                var placesService = new google.maps.places.PlacesService(map);
                if($(this).data('category') === 'bar') {
                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        keyword:  'bar',
                        radius:   3000,
                        type:     ['bar']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'bar');
                            }
                        }
                    });

                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        keyword:  'eetcafe',
                        radius:   3000,
                        type:     ['restaurant']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'bar');
                            }
                        }
                    });

                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        radius:   3000,
                        keyword:  'night clubs',
                        type:     ['night_club']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'bar');
                            }
                        }
                    });

                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        radius:   3000,
                        keyword:  'cafe',
                        type:     ['cafe']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'bar');
                            }
                        }
                    });
                } else if($(this).data('category') === 'restaurant') {
                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        radius:   3000,
                        keyword:  'restaurants',
                        type:     ['restaurant']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'restaurant');
                            }
                        }
                    });

                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        radius:   3000,
                        keyword:  'restaurant',
                        type:     ['restaurant']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'restaurant');
                            }
                        }
                    });

                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        keyword:  'eetcafe',
                        radius:   3000,
                        type:     ['restaurant']
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], 'restaurant');
                            }
                        }
                    });
                } else {
                    var $this = $(this);
                    placesService.nearbySearch({
                        location: {
                            lat: $('#google-map').data('lat'),
                            lng: $('#google-map').data('lng')
                        },
                        radius:   3000,
                        type:     [$(this).data('category')]
                    }, function(result, status) {
                        if(status === google.maps.places.PlacesServiceStatus.OK) {
                            for(var i = 0; i < result.length; i++) {
                                createMarker(result[i], $this.data('category'));
                            }
                        }
                    });
                }
            }
        });
        timeout = false;
    }

    function clearPointsOfInterestMarkers() {
        for(var i = 0; i < pointsOfInterest.length; i++) {
            pointsOfInterest[i].setMap(null);
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {

    var mn  = $('.about-menu-container'),
        mns = 'about-menu-container-scrolled',
        bit, hdr;

    $(window).resize(function() {

        bit = mn.outerHeight();
        hdr = $('.intro-sub').outerHeight();
    })
        .resize().scroll(function() {

        if($(this).scrollTop() > hdr) {
            mn.addClass(mns);
            //core.css('margin-top', bit);
        } else {
            mn.removeClass(mns);
            //core.attr('style', '');
        }
    })
        .on('load', function() {
            $(this).scroll();
        });
});
